<template>
	<KkIcon
		v-if="leadingImageConfig.type === 'KkIcon'"
		class="kk-select-leading-image kk-select-leading-image--icon"
		:class="classes"
		v-bind="{ ...leadingImageConfig.props, size: 'sm' }"
	/>
	<KkAvatar
		v-else-if="leadingImageConfig.type === 'KkAvatar'"
		class="kk-select-leading-image kk-select-leading-image--avatar"
		:class="classes"
		v-bind="{ ...leadingImageConfig.props, size: 'xs' }"
	/>
	<img
		v-else
		class="kk-select-leading-image kk-select-leading-image--image"
		:class="classes"
		:src="leadingImageConfig.props.src"
		:alt="leadingImageConfig.props.alt || ''"
		width="20"
	>
</template>

<script>
import KkIcon from '../../KkIcon';
import KkAvatar from '../../KkAvatar';

export default {
	name: 'KkSelectLeadingImage',
	components: {
		KkIcon,
		KkAvatar,
	},
	props: {
		/*
			{
				type: 'KkIcon', 'KkAvatar', 'image',
				props: {
					// 依據 type 決定傳入元件的設定
				}
			}
		 */
		config: {
			type: [String, Object],
			default: null
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		leadingImageConfig() {
			if (!this.config) {
				return;
			}
			if (typeof this.config === 'string') {
				return {
					type: 'KkIcon',
					props: {
						name: this.config,
					}
				}
			}
			return this.config;
		},
		classes() {
			return {
				'kk-select-leading-image--disabled': this.isDisabled,
			}
		},
	},
}
</script>
